export default (countdown, callback) => {
  let dateStart = null;
  let dateEnd = null;
  let timeout = null;
  let elapsed = 0;

  function pause() {
    clearTimeout(timeout);
    elapsed += Date.now() - dateStart;
  }

  function start() {
    dateStart = Date.now();
    dateEnd = dateStart + countdown - elapsed;
    timeout = setTimeout(callback, dateEnd - dateStart);
  }

  function stop() {
    clearTimeout(timeout);
    elapsed = 0;
  }

  return {
    pause,
    start,
    stop,
  };
}
